import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { QueryDefinitionDto } from '../../shared/dto/query-definition.dto';
import { SelectItem } from 'primeng/api';
import { BinaryOperatorEnum } from 'src/app/shared/search-expression/binary-operator.enum';
import { TranslationService } from 'src/app/shared';
import { ReportService } from '../../shared/report-service';
import { ColumnDefinitionDto } from '../../shared/dto/column-definition.dto';
import { QueryFilterExpression } from '../../shared/dto/query-filter-expression.dto';
import { FieldValueOperatorEnum } from 'src/app/shared/search-expression/field-value-operator.enum';
import { DatePeriodEnum } from 'src/app/shared/search-expression/date-period.enum';

@Component({
  selector: 'wl-query-tool-set-filters',
  templateUrl: './query-tool-set-filters.component.html',
  styleUrls: ['./query-tool-set-filters.component.less'],
    standalone: false
})
export class QueryToolSetFiltersComponent implements OnInit, OnChanges {
  @Input() queryDefinition: QueryDefinitionDto;
  setOperators: SelectItem<SelectItem>[];
  groups: Array<number> = [1, 2];
  @Input() availableFields: Array<ColumnDefinitionDto>;
  @Output() onFilterChanged = new EventEmitter<string>();

  fieldValueOperators: Array<SelectItem>;
  dateFieldValueOperators: Array<SelectItem>;
  datePeriodOptions: Array<SelectItem>;
  fieldValueOperatorEnum = FieldValueOperatorEnum;
  stringFieldValueOperators: Array<SelectItem>;

  constructor(private _translationService: TranslationService) {}

  ngOnInit(): void {
    setTimeout(() => {
      const andString = this._translationService.getInstantTitlecase('common.and');
      const orString = this._translationService.getInstantTitlecase('common.or');
      this.setOperators = [
        { label: andString, value: BinaryOperatorEnum.And } as SelectItem,
        { label: orString, value: BinaryOperatorEnum.Or } as SelectItem,
      ];

      const equals = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.equals');
      const notEquals = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.not-equal');
      const greaterThan = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.greater-than');
      const greaterThanEqualTo = this._translationService.getInstantTitlecase(
        'shared.widgets.expression.value-operator.greater-than-or-equal-to'
      );
      const lessThan = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.less-than');
      const lessThanEqualTo = this._translationService.getInstantTitlecase(
        'shared.widgets.expression.value-operator.less-than-or-equal-to'
      );
      const contains = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.contains');
      const notContains = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.does-not-contain');
      const inPeriod = this._translationService.getInstantTitlecase('shared.widgets.expression.value-operator.in-the-period');

      const lastOneDay = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.last-1-day');
      const lastSeventDays = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.last-7-days');
      const lastThirtyDays = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.last-30-days');
      const monthToDate = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.month-to-date');
      const previousMonth = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.previous-month');
      const yearToDate = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.year-to-date');
      const previousYear = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.previous-year');

      const nextSevenDays = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.next-7-days');
      const nextThirtyDays = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.next-30-days');
      const nextSixtyDays = this._translationService.getInstantTitlecase('shared.widgets.expression.date-period-options.next-60-days');

      this.fieldValueOperators = [
        { label: equals, value: FieldValueOperatorEnum.Equals } as SelectItem,
        { label: greaterThan, value: FieldValueOperatorEnum.GreaterThan } as SelectItem,
        { label: greaterThanEqualTo, value: FieldValueOperatorEnum.GreaterThanOrEqual } as SelectItem,
        { label: lessThan, value: FieldValueOperatorEnum.LessThan } as SelectItem,
        { label: lessThanEqualTo, value: FieldValueOperatorEnum.LessThanOrEqual } as SelectItem,
        { label: contains, value: FieldValueOperatorEnum.Contains } as SelectItem,
      ];

      this.dateFieldValueOperators = [
        { label: equals, value: FieldValueOperatorEnum.Equals } as SelectItem,
        { label: greaterThan, value: FieldValueOperatorEnum.GreaterThan } as SelectItem,
        { label: greaterThanEqualTo, value: FieldValueOperatorEnum.GreaterThanOrEqual } as SelectItem,
        { label: lessThan, value: FieldValueOperatorEnum.LessThan } as SelectItem,
        { label: lessThanEqualTo, value: FieldValueOperatorEnum.LessThanOrEqual } as SelectItem,
        { label: contains, value: FieldValueOperatorEnum.Contains } as SelectItem,
        { label: inPeriod, value: FieldValueOperatorEnum.InPeriod } as SelectItem,
      ];

      this.datePeriodOptions = [
        { label: lastOneDay, value: DatePeriodEnum.Last1Day.toString() } as SelectItem,
        { label: lastSeventDays, value: DatePeriodEnum.Last7Days.toString() } as SelectItem,
        { label: lastThirtyDays, value: DatePeriodEnum.Last30Days.toString() } as SelectItem,
        { label: monthToDate, value: DatePeriodEnum.MonthToDate.toString() } as SelectItem,
        { label: previousMonth, value: DatePeriodEnum.PreviousMonth.toString() } as SelectItem,
        { label: yearToDate, value: DatePeriodEnum.YearToDate.toString() } as SelectItem,
        { label: previousYear, value: DatePeriodEnum.PreviousYear.toString() } as SelectItem,
        { label: nextSevenDays, value: DatePeriodEnum.Next7Days.toString() } as SelectItem,
        { label: nextThirtyDays, value: DatePeriodEnum.Next30Days.toString() } as SelectItem,
        { label: nextSixtyDays, value: DatePeriodEnum.Next60Days.toString() } as SelectItem,
      ];
      this.stringFieldValueOperators = [
        { label: equals, value: FieldValueOperatorEnum.Equals } as SelectItem,
        { label: notEquals, value: FieldValueOperatorEnum.NotEqual } as SelectItem,
        { label: greaterThan, value: FieldValueOperatorEnum.GreaterThan } as SelectItem,
        { label: greaterThanEqualTo, value: FieldValueOperatorEnum.GreaterThanOrEqual } as SelectItem,
        { label: lessThan, value: FieldValueOperatorEnum.LessThan } as SelectItem,
        { label: lessThanEqualTo, value: FieldValueOperatorEnum.LessThanOrEqual } as SelectItem,
        { label: contains, value: FieldValueOperatorEnum.Contains } as SelectItem,
        { label: notContains, value: FieldValueOperatorEnum.DoesNotcontain } as SelectItem,
      ];
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.queryDefinition) {
      this.groups = Array.from(
        { length: Math.max(...this.queryDefinition.SearchExpressions?.map((x) => x.FilterGroup), 2) },
        (x, i) => i + 1
      );
    }
  }

  groupSelected() {
    const maxGroup = Math.max(...this.groups);
    const maxSelectedGroup = Math.max(...this.queryDefinition.SearchExpressions.map((x) => x.FilterGroup));
    if (maxGroup == maxSelectedGroup) {
      this.groups.push(maxGroup + 1);
    }
  }

  addFilterClicked() {
    this.queryDefinition.SearchExpressions.push({
      FilterGroup: 1,
      SetOperator: BinaryOperatorEnum.And,
      FieldValueOperator: FieldValueOperatorEnum.Equals,
    } as QueryFilterExpression);
    this.filterChanged();
  }

  remove(rowIndex: number) {
    this.queryDefinition.SearchExpressions.splice(rowIndex, 1);
    this.filterChanged();
  }

  filterChanged() {
    this.onFilterChanged.emit();
  }

  fieldChanged($event, rowIndex: number) {
    this.queryDefinition.SearchExpressions[rowIndex].FieldType = this.availableFields.find((x) => x.ColumnName == $event.value)?.ColumnType;
    this.filterChanged();
  }

  numberChanged(rowIndex: number) {
    this.queryDefinition.SearchExpressions[rowIndex].Value = this.queryDefinition.SearchExpressions[rowIndex].Value.toString();
    this.onFilterChanged.emit();
  }
}
